var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlorist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 493.86 493.86",
    style: {
      enableBackground: "new 0 0 493.86 493.86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB90B"
    },
    d: "M338.514,110.58c0,6.096-4.976,19.608-11.12,19.608c-6.128,0-11.048-13.504-11.048-19.608 c0-6.128,4.92-11.096,11.048-11.096C333.538,99.484,338.514,104.452,338.514,110.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB90B"
    },
    d: "M316.354,156.028c0-6.104,4.92-19.608,11.048-19.608c6.144,0,11.12,13.504,11.12,19.608 c0,6.128-4.976,11.096-11.12,11.096C321.274,167.124,316.354,162.156,316.354,156.028z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E0B"
    },
    d: "M351.346,125.068c-4.344,4.336-17.384,10.352-21.704,6.008c-4.32-4.312,1.696-17.36,6.016-21.68 c4.32-4.336,11.344-4.336,15.688,0C355.658,113.716,355.658,120.74,351.346,125.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E0B"
    },
    d: "M303.522,141.54c4.312-4.32,17.36-10.344,21.688-6.016c4.32,4.32-1.696,17.352-6.008,21.68 c-4.344,4.336-11.368,4.336-15.68,0C299.194,152.884,299.194,145.868,303.522,141.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB90B"
    },
    d: "M350.138,144.396c-6.096,0-19.6-4.984-19.6-11.12c0-6.12,13.504-11.048,19.6-11.048 c6.128,0,11.096,4.928,11.096,11.048C361.234,139.412,356.266,144.396,350.138,144.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB90B"
    },
    d: "M304.714,122.228c6.08,0,19.6,4.928,19.6,11.048c0,6.136-13.52,11.12-19.6,11.12 c-6.144,0-11.112-4.984-11.112-11.12C293.602,127.164,298.57,122.228,304.714,122.228z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E0B"
    },
    d: "M335.658,157.212c-4.32-4.328-10.336-17.368-6.016-21.68c4.32-4.328,17.36,1.696,21.704,6.016 c4.312,4.328,4.312,11.336,0,15.664C347.002,161.548,339.978,161.548,335.658,157.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E0B"
    },
    d: "M319.202,109.396c4.312,4.328,10.328,17.368,6.008,21.68c-4.328,4.336-17.376-1.672-21.688-6.008 c-4.328-4.328-4.328-11.344,0-15.672C307.834,105.06,314.858,105.06,319.202,109.396z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 168.93,
    y: 285.86,
    style: {
      fill: "#F9BDA0"
    },
    width: 160,
    height: 168
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFFFF"
    },
    d: "M462.45,327.22l-118.464-41.504l2.496-6.992l-15.488-6.632c-6.184,28-40.528,49.392-82.08,49.392 c-41.56,0-75.888-21.496-82.072-49.496l-15.504,6.488l2.504,6.712L35.41,327.228L12.93,493.86h29.952h152.752h46.312h13.968h48.472 h150.592h29.952L462.45,327.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7F2F2"
    },
    d: "M8.93,493.86h33.952h152.752h46.312h13.968h48.472h150.592h29.952l-22.48-166.64l-118.464-41.504 l2.496-6.992l-15.488-6.632c-6.184,28-40.528,49.392-82.08,49.392c-41.56,0-75.888-21.496-82.072-49.496l-15.504,6.488l0.504,7.784"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CAD8D8"
    },
    d: "M240.93,493.86h14.984h48.472h150.592h29.952l-22.48-166.64l-118.464-41.504l2.496-6.992 l-15.488-6.632c-6.184,28-41.04,50.464-82.584,50.464"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#B6D1D0"
    },
    points: "360.93,493.86 369.546,493.86 420.882,493.86 454.978,493.86 484.93,493.86 462.45,327.22  343.994,285.716 344.618,279.796 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "308.618,301.86 191.018,301.86 198.866,205.86 300.778,205.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "310.482,302.364 248.938,463.652 187.378,302.364 248.938,303.028  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E28F71"
    },
    points: "308.626,302.988 262.042,398.652 191.034,205.86 300.786,205.86 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M326.746,137.54c0-68.248-29.816-95.856-77.816-96.136v-0.032v0.016v-0.016v0.032 c-48,0.272-77.816,27.888-77.816,96.136S200.93,267.5,248.93,268.972v0.144c0,0,0-0.064,0-0.072c0,0.008,0,0.072,0,0.072v-0.144 C296.93,267.5,326.746,205.796,326.746,137.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M248.93,269.86v-0.752c0,0,0-0.064,0-0.072c0,0.008,0,0.072,0,0.072v-0.144 c48-1.472,77.816-63.176,77.816-131.424S296.93,41.684,248.93,41.404v-0.032v0.016v-0.016V37.86"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M170.882,116.844c-4.216-1.848-3.376-14.36,0.336-22.832c3.728-8.48,10.176-21.64,14.384-19.776 c4.232,1.856,7.744,20.248,0.912,26.504"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M328.746,116.66c4.232-1.864,3.44-14.368-0.272-22.832S318.33,72.22,314.106,74.084 s-7.76,20.28-0.928,26.504"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M205.858,218.26c-0.192-0.224-0.304-0.368-0.304-0.368S205.634,218.1,205.858,218.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M293.778,218.26c0.192-0.224,0.304-0.368,0.304-0.368S294.01,218.1,293.778,218.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFFFF"
    },
    d: "M334.202,73.86c0,15.344,3.144,28-12.192,28H175.834c-15.336,0-12.176-12.656-12.176-28l0,0 c0-15.336-10.952-28,4.384-28H329.81C345.138,45.86,334.202,58.524,334.202,73.86L334.202,73.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFFFF"
    },
    d: "M179.85,46.708c0,0,5.208,1.952,22.096-17.536s29.232-5.84,33.136-1.296s-3.896-4.544-3.896-4.544 s15.6-32.488,20.136-20.792c4.552,11.696,0,67.568,0,67.568l-62.376,22.736l-8.44-43.528"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAEA"
    },
    d: "M333.794,45.86h-15.256l0.08-0.336c0,0-0.064,0.336-0.216,0.336H307.69 c-2.968,0-6.632-4.264-11.16-9.488c-16.896-19.496-29.248-13.336-33.144-8.792c-3.896,4.544,3.888-4.4,3.888-4.4 s-21.08-25.432-20.128-12.92c0.416,5.536,0.744,21,1,37.664c-3.344,2.832-0.128,12.6,0.296,24.536 c0.016,1.152,0.032,1.912,0.04,3.024c-0.336,14.856-7.464,26.376,0.224,26.376h81.096c7.864,0,6.24-12.656,6.24-28 C336.042,58.524,341.666,45.86,333.794,45.86z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CAD8D8"
    },
    d: "M248.93,101.86h80.864c7.864,0,6.24-12.656,6.24-28c0-15.336,5.624-28-2.24-28h-15.256l0.08-0.336 c0,0-0.064,0.336-0.216,0.336H304.93"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD3D3"
    },
    d: "M248.45,72.484c0.016,1.152,0.032,2.272,0.04,3.384"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.93,
    y: 389.86,
    style: {
      fill: "#E7F2F2"
    },
    width: 104,
    height: 104
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB30B"
    },
    cx: 262.842,
    cy: 419.804,
    r: 11.208
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8908"
    },
    d: "M262.842,408.596c6.176,0,11.208,5.016,11.208,11.208c0,6.184-5.032,11.2-11.208,11.2"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB30B"
    },
    cx: 262.842,
    cy: 464.1,
    r: 11.208
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8908"
    },
    d: "M262.842,452.94c6.176,0,11.208,5.016,11.208,11.2c0,6.192-5.032,11.208-11.208,11.208"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlorist);
export default __webpack_public_path__ + "static/media/florist.1826cdbb423ea105617e0bac1943380d.svg";
export { ForwardRef as ReactComponent };